<template>
  <ga-product-card-cart-button v-bind="propsToPass" @click="onCartClick" />
</template>

<script src="./cart-adapter.scripts.js" />
